<header>QRGen</header>
<main class="container">
    <div class="row pb-5">
        <div class="col-12">
            <input type="text" placeholder="text" [(ngModel)]="data" class="text text-center">
        </div>
    </div>
    <div class="row pb-4">
        <div class="col-12 col-sm-6 pb-5 pb-sm-0 text-center my-auto">
            <div class="d-flex justify-content-center pb-5">
                <div [(colorPicker)]="colorD" [style.background]="colorD" [cpPosition]="'bottom'" class="cpicker mr-4"></div>
                <div [(colorPicker)]="colorL" [style.background]="colorL" [cpPosition]="'bottom'" class="cpicker"></div>
            </div>
            <a href="{{link}}" id="dllink" download="{{data}}.jpg">download</a>
        </div>
        <div class="col-12 col-sm-6 text-center my-auto">
            <qrcode [elementType]="'jpg'" [qrdata]="data" [width]="256" [errorCorrectionLevel]="'H'"
                [colorDark]="colorD" [colorLight]="colorL" [margin]="2"></qrcode>
        </div>
    </div>
    <div class="row">
        Made with ❤ by &nbsp; <a href="https://jaymakwana.ml"> Jay Makwana</a>
    </div>
</main>